












































import { Component, Prop, Vue } from 'vue-property-decorator';
import api from '@/api/apiclient';
import { IBlogCalendarItem, ITag } from '@/api/interface';

interface IBlogFormCalendarItem extends IBlogCalendarItem{
  selected: boolean;
}

interface IBlogFormTag extends ITag {
  selected: boolean;
}

interface IBlogFormFilter {
  tag: string[];
  date: string[];
  page: string[];
}

@Component
export default class BlogFilterForm extends Vue {

  @Prop({ default: '/blog/filter/' })
  private baseHref!: string;

  @Prop({ default: '/blog' })
  private resetHref!: string;

  private calendar: IBlogFormCalendarItem[] = [];
  private tags: IBlogFormTag[] = [];

  private filterFromUrl() {
    const filter: IBlogFormFilter = {
      tag:  [],
      date: [],
      page: []
    };
    if (window.location.pathname.indexOf(this.baseHref) > -1) {
      const arr = window.location.pathname.slice(this.baseHref.length).split('/').filter(a => !!a.length);
      let param: 'tag' | 'date' | 'page';
      arr.forEach(val => {
        switch (val) {
          case 'tag':
          case 'date':
          case 'page':
            param = val;
            break;
          default:
            try {
              const decoded = decodeURIComponent(val);
              if (filter[param]) filter[param].push(decoded);
            }
            catch (e) {
              console.log(e);
            }

        }
      });
    }
    return filter;
  }

  private filterToUrl() {
    const filter: IBlogFormFilter = {
      tag: this.tags.filter(t => t.selected).map(t => encodeURIComponent(t.name)),
      date: this.calendar.filter(d => d.selected).map(d => d.year.toString()),
      page: []
    };
    let url = this.baseHref.slice(0, -1);
    Object.entries(filter).forEach(([key, a]) => {
      if (a.length) url += '/' + key + '/' + a.join('/');
    });
    return url;
  }

  mounted() {
    const filter = this.filterFromUrl();

    api.get<IBlogCalendarItem[]>('/cms/api/blog/calendar').then(data => {
      if (data) this.calendar = data.map(d => Object.assign(d, {
        selected: filter.date.some(item => d.year.toString() === item.slice(0, 4))
      }));
    }).catch(e => console.log(e.message || e));

    api.get<ITag[]>('/cms/api/blog/tags').then(data => {
      if (data) this.tags = data.map(d => Object.assign(d, { selected: filter.tag.includes(d.name) }));
    }).catch(e => console.log(e.message || e));
  }

  onSubmit(e: Event) {
    if (e && e.preventDefault) e.preventDefault();
    this.$nextTick(() => {
      window.location.href = this.filterToUrl();
    });
    return false;
  }

  onReset(e: Event) {
    if (e && e.preventDefault) e.preventDefault();
    window.location.href = this.resetHref;
    return false;
  }
}
